import { useEffect, useState } from 'react'

export const useAutoRedirect = (url?: string, timeoutSeconds?: number) => {
    const [secondsLeft, setSecondsLeft] = useState<number | null>(timeoutSeconds || null)

    useEffect(() => {
        // Если нет URL или таймаута - не запускаем редирект
        if (!url || timeoutSeconds === null) {
            setSecondsLeft(null)
            return
        }

        setSecondsLeft(timeoutSeconds || null)

        const interval = setInterval(() => {
            setSecondsLeft(prev => {
                if (prev === null || prev <= 1) {
                    clearInterval(interval)
                    window.location.href = url
                    return 0
                }
                return prev - 1
            })
        }, 1000)

        return () => clearInterval(interval)
    }, [url, timeoutSeconds])

    const redirect = () => {
        if (url) {
            window.location.href = url
        }
    }

    return { secondsLeft, redirect }
}
